import { GroupIds } from "@/configuration/group-ids";
import {
  SchedulingCancellationStrategy,
  SchedulingChannel,
  type SchedulingCustomerConfig,
  SchedulingSmsAvailabilityStrategy,
  SchedulingSmsEligibilityStrategy,
  SchedulingVoiceWorkflow,
} from "@/customer-interface/scheduling";

/** Voice admits the live cohort; SMS remains sandbox-only. Caller opt-in is separate. */
export const sportOrthoSchedulingConfig = {
  appointmentQuery: {
    enabledGroupIds: { [SchedulingChannel.Sms]: [GroupIds.SPORTORTHO_LIVE_SANDBOX] },
  },
  locationQuery: {
    enabledGroupIds: { [SchedulingChannel.Sms]: [GroupIds.SPORTORTHO_LIVE_SANDBOX] },
  },
  policy: {
    scheduleConfigPath: "configuration/groups/sportortho/rules/schedule.yaml",
  },
  voice: {
    workflow: SchedulingVoiceWorkflow.Deterministic,
    workflowEnabledGroupIds: [GroupIds.SPORTORTHO_LIVE_SANDBOX, GroupIds.SPORTORTHO_LIVE],
    cancellation: SchedulingCancellationStrategy.Staff,
    optionSearch: {
      progressiveChronologicalWindows: false,
      progressivePolicyRankedWindows: false,
      progressiveLinkedUnitWindows: false,
    },
  },
  sms: {
    eligibility: SchedulingSmsEligibilityStrategy.Agentic,
    eligibilityEnabledGroupIds: [GroupIds.SPORTORTHO_LIVE_SANDBOX],
    availability: SchedulingSmsAvailabilityStrategy.AgenticProvider,
    availabilityEnabledGroupIds: [GroupIds.SPORTORTHO_LIVE_SANDBOX],
    bookingEnabledGroupIds: [GroupIds.SPORTORTHO_LIVE_SANDBOX],
  },
} as const satisfies SchedulingCustomerConfig;
